import { useSuspenseQuery } from '@tanstack/react-query'
import { Outlet } from 'react-router'

import { AppLayout } from 'apps/employer_dashboard/components/AppLayout'
import { getDashboardEmployers, getGetDashboardEmployersQueryKey } from 'utils/web_api'

export function AppPage () {
  const { data: dashboardContext } = useSuspenseQuery({
    queryKey: getGetDashboardEmployersQueryKey(),
    queryFn: getDashboardEmployers
  })

  return (
    <AppLayout dashboardContext={dashboardContext}>
      <Outlet />
    </AppLayout>
  )
}
